var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTriangleDestination = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.662,
    height: 4.271,
    viewBox: "0 0 6.662 4.271",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_TriangleDestination",
    d: "M.081-3.744,3.1-.105a.318.318,0,0,0,.473,0L6.581-3.744a.316.316,0,0,0-.236-.527H.317A.316.316,0,0,0,.081-3.744Z",
    transform: "translate(0 4.271)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTriangleDestination);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_triangle_destination.e95f54b6354e329ee79827e545d18a7e.svg";